export const fetcher = (url: string) => fetch(url).then((res) => res.json());

export const tokensFetcher = (url: string) =>
  fetch(url)
    .then((res) => res.json())
    .then((e) => {
      return e.tokens;
    });

export const boardsFetcher = (url: string) =>
  fetch(url)
    .then((res) => res.json())
    .then((e) => {
      return e.token_lists;
    });

export const collectionsFetcher = (url: string) =>
  fetch(url)
    .then((res) => res.json())
    .then((e) => {
      return e.collections;
    });

export const auctionsFetcher = (url: string) =>
  fetch(url)
    .then((res) => res.json())
    .then((e) => e);

export const swapsFetcher = (url: string) =>
  fetch(url)
    .then((res) => res.json())
    .then((e) => e);
